import { types } from 'mobx-state-tree';

export const MessageSourceMST = types.enumeration('MessageSourceMST', [
  'user',
  'system',
]);
